// extracted by mini-css-extract-plugin
export default {"textPage":"TextPage_textPage__SBiYB","textSection":"TextPage_textSection__I7230"};